import { MaterialIcon } from "@website/icons/material";
import { InputPropertiesType } from "@website/ui-old/datepicker/components/input/input.types";
import { numberConvert } from "@website/utils/number-convert";
import { useCallback, useMemo } from "react";

/**
 * @deprecated please use @website/ui instead
 */
export const useInput = (properties: InputPropertiesType) => {
  const {
    fromTitle,
    toTitle,
    value,
    setMode,
    calendarLocale,
    onOpenPopover,
    disabled,
    secondaryMode,
    onFocusStart,
    onFocusEnd,
    hideIcons,
    hideBorders,
    hasTitleLabel
  } = properties;

  const onChangeModeClick = useCallback(() => {
    setMode && secondaryMode && setMode(secondaryMode);
  }, [secondaryMode, setMode]);

  const MONTH_NAMES: Record<string, Array<string>> = {
    persian: [
      "فروردین",
      "اردیبهشت",
      "خرداد",
      "تیر",
      "مرداد",
      "شهریور",
      "مهر",
      "آبان",
      "آذر",
      "دی",
      "بهمن",
      "اسفند"
    ],
    gregorian: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  };

  const startTextFieldValue = useMemo(() => {
    if (value[0]) {
      const month = (MONTH_NAMES[calendarLocale] || MONTH_NAMES.gregorian)[
        value[0].month - 1
      ];
      const day = numberConvert(value[0].day, {
        numberOnly: true,
        locale: "fa"
      });

      return `${day} ${month}`;
    }
    return "";
  }, [value, calendarLocale]);

  const endTextFieldValue = useMemo(() => {
    if (value[1]) {
      const month = (MONTH_NAMES[calendarLocale] || MONTH_NAMES.gregorian)[
        value[1].month - 1
      ];
      const day = numberConvert(value[1].day, {
        numberOnly: true,
        locale: "fa"
      });

      return `${day} ${month}`;
    }
    return "";
  }, [calendarLocale, value]);

  return {
    rootProps: {
      tabIndex: 0
    },
    startTextFieldProperties: {
      label: value[0] ? fromTitle ?? "تاریخ شروع" : "",
      placeholder: value[0] ? "" : fromTitle ?? "تاریخ شروع",
      hasTitleLabel,
      StartIcon: hideIcons ? undefined : (
        <MaterialIcon name="date_range" variant="fill" />
      ),
      readOnly: true,
      value: startTextFieldValue,
      hideBorders,
      onClick: () => {
        onOpenPopover && onOpenPopover();
        if (value[0] && value[1]) {
          onFocusStart && onFocusStart();
        }
      },
      fullWidth: true,
      disabled
    },
    endTextFieldProperties: {
      label: value[1] ? toTitle ?? "تاریخ پایان" : "",
      placeholder: value[1] ? "" : toTitle ?? "تاریخ پایان",
      readOnly: true,
      value: endTextFieldValue,
      hasTitleLabel,
      hideBorders,
      onClick: () => {
        onOpenPopover && onOpenPopover();
        if (value[0] && value[1]) {
          onFocusEnd && onFocusEnd();
        }
      },
      fullWidth: true,
      disabled
    },
    endEnableButtonProperties: {
      role: "button",
      onClick: () => {
        onChangeModeClick();
        if (value[0] && value[1]) {
          onFocusEnd && onFocusEnd();
        }
      }
    },
    endEnableButtonText: toTitle ?? "تاریخ پایان"
  };
};
